export default "__VITE_PUBLIC_ASSET__efcb223e__"